<template>
  <div class="headerDIV">
    <div class="headerdiv">
      <div class="head">
        <div style="display:flex;align-items: center;">
          <img
            @click="backIndex"
            style="cursor: pointer;width:120px;margin-right:14px"
            src="../../assets/logo.png"
          />
          <p class="hy">
            <span style="padding-left:10px;">欢迎 {{ name }}</span>
          </p>
        </div>
        <div style="display:flex;align-items:center;">
          <p
            class="quit"
            style="color:#333;"
            id="quit"
            @click="goIndex"
            :style="
              pathUrl == '/phyExServices'
                ? 'font-weight:bold'
                : 'font-weight:normal;'
            "
          >
            体检服务
          </p>
          <p
            style="width:2px;height:20px;background:#333;margin-left:20px;"
          ></p>
          <p
            class="quit"
            style="color:#333;"
            v-if="pathUrl != '/personal'"
            id="quit"
            @click="personal"
            :style="
              pathUrl == '/personal'
                ? 'font-weight:bold'
                : 'font-weight:normal;'
            "
          >
            个人中心
          </p>
          <p
            class="quit"
            style="color:#333;"
            v-else
            id="quit"
            @click="backIndex"
            :style="
              pathUrl == '/personal'
                ? 'font-weight:bold'
                : 'font-weight:normal;'
            "
          >
            个人中心
          </p>
          <p
            style="width:2px;height:20px;background:#333;margin-left:20px;"
          ></p>
          <p
            class="quit"
            style="text-decoration: underline;"
            id="quit"
            @click="quit"
          >
            退出
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "headDIV",
  data() {
    return {
      isShowLang: false,
      nationality: "",
      pathUrl: "",
      name: ""
    };
  },
  async created() {
    let _this = this;
    _this.nationality = localStorage.getItem("nationality");
    _this.changeLangCss();
    if (localStorage.getItem("TOKEN") != null) {
      _this.$store.dispatch("setUser", localStorage.getItem("username"));
    }
    _this.pathUrl = _this.$route.path;
    await axios.get(BASE_URL + "/exam/projects/").then(res => {
      axios
        .get(
          BASE_URL + `/exam/project/staff_info/?code=${res.data.data[0].code}`
        )
        .then(res => {
          _this.name = res.data.data.realname;
          sessionStorage.setItem(
            "self_paid_packages_total_count",
            res.data.data.self_paid_packages_total_count
          );
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    });
  },
  async activated() {
    let _this = this;
    if (!_this.$route.meta.isBack || _this.isFirstEnter) {
      await axios.get(BASE_URL + "/exam/projects/").then(res => {
        axios
          .get(
            BASE_URL + `/exam/project/staff_info/?code=${res.data.data[0].code}`
          )
          .then(res => {
            _this.name = res.data.data.realname;
            sessionStorage.setItem(
              "self_paid_packages_total_count",
              res.data.data.self_paid_packages_total_count
            );
          })
          .catch(err => {
            // _this.fullscreenLoading = false;
          });
      });
    }
  },
  methods: {
    ...mapActions(
      // 语法糖
      [
        "changeShow",
        "changeHide",
        "setNavName",
        "changeZH",
        "changeEN",
        "changeLangCss"
      ] // 相当于this.$store.dispatch('modifyName'),提交这个方法
    ),
    goIndex() {
      this.$router.push("/phyExServices");
    },
    personal() {
      this.$router.push("/personal");
      this.pathUrl = this.$route.path;
    },
    backIndex() {
      this.$router.push("/phyExServices");
      this.pathUrl = this.$route.path;
    },
    quit() {
      let _this = this;
      _this
        .$confirm(_this.$t("m.common.isQuit"), {
          confirmButtonText: _this.$t("m.common.define"),
          cancelButtonText: _this.$t("m.common.cancelBtn")
          // type: 'warning'
        })
        .then(() => {
          // localStorage.clear();
          localStorage.removeItem("username");
          localStorage.removeItem("TOKEN");
          localStorage.removeItem("companyName");
          sessionStorage.clear();
          _this.$store.dispatch("quitUser");
          _this.$router.replace({
            path: "/"
          });
          _this.$message({
            type: "success",
            center: true,
            message: _this.$t("m.common.quitSuccess")
          });
        })
        .catch(() => {
          // _this.$message({
          //   type: 'info',
          //   center: true,
          //   message: '已取消'
          // });
        });
    },
    home() {
      let _this = this;
      _this.$router.replace({
        path: "/index"
      });
    },
    tjService() {
      let _this = this;
      _this.$router.replace({
        path: "/phyExServices"
      });
    },
    my() {
      let _this = this;
      _this.$router.replace({
        path: "/personal"
      });
    },
    healthLife() {
      //this.$router.resolve({ path: '/test' })
      let _this = this;
      let routeLife = _this.$router.resolve({
        path: "/healthLife"
      });
      window.open(routeLife.href);
    },
    healthCheck() {
      let _this = this;
      let routeCheck = _this.$router.resolve({
        path: "/healthCheck"
      });
      window.open(routeCheck.href);
    },
    healthInsurancePlan() {
      let _this = this;
      let routeHIP = _this.$router.resolve({
        path: "/healthInsurancePlan"
      });
      window.open(routeHIP.href);
    },
    healthLife2() {
      //this.$router.resolve({ path: '/test' })
      let _this = this;
      _this.$router.replace({
        path: "/healthLife"
      });
    },
    healthCheck2() {
      let _this = this;
      _this.$router.replace({
        path: "/healthCheck"
      });
    },
    healthInsurancePlan2() {
      let _this = this;
      _this.$router.replace({
        path: "/healthInsurancePlan"
      });
    },
    toMyorder() {
      let _this = this;
      _this.$router.replace({
        path: "/myorder"
      });
    }
  },
  computed: {
    ...mapGetters([
      "navStatus",
      "qhText",
      "isLogin",
      "currentUser",
      "navName",
      "isHealth"
    ]) // 动态计算属性，相当于this.$store.getters.resturantName
  }
};
</script>

<style scoped>
.langActive {
  color: #ff000f !important;
}

.active {
  background: #006199;
}

.headerdiv {
  width: 100%;
  height: 80px;
  background-color: #fff;
  box-shadow: 0px 0px 50px 0px #eaeaea;
}

.head {
  width: 1180px;
  height: 80px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.head p {
  /* float: right; */
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 15px;
}

.myOrder,
.myCart {
  padding: 0 20px;
  border-right: 2px solid #eaeaea;
  cursor: pointer;
}

.quit {
  padding-left: 20px;
  cursor: pointer;
}

#quit {
  color: #ff000f;
  /* text-decoration: underline; */
}

.logodiv {
  width: 100%;
}

.logo {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.logo img {
  width: 150px;
  margin: 20px 0;
}

.logo .lang {
  display: flex;
  align-items: center;
}

.logo .lang .zh,
.logo .lang .en {
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  text-decoration: underline;
  cursor: pointer;
}

.logo .lang .icon {
  width: 2px;
  height: 16px;
  background: #333;
  margin: 0 10px;
}

.navdiv {
  width: 100%;
  height: 46px;
  background-color: #ff000f;
}

.nav {
  width: 1180px;
  height: 46px;
  margin: 0 auto;
  position: relative;
}

.nav ul {
  width: 100%;
  height: 46px;
}

.nav ul li {
  width: 50%;
  height: 46px;
  float: left;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  line-height: 20px;
  cursor: pointer;
}
/*.nav ul li:hover{
		background-color: #006199;
	}*/

.twomenu {
  width: 25%;
  height: 138px;
  background-color: #ff000f;
  position: absolute;
  z-index: 100;
  top: 47px;
  left: 50%;
}

.twomenu p {
  height: 45px;
  width: 260px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  line-height: 16px;
  border-bottom: 1px solid #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin: 0 auto;
}

.twomenu p:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue